export default "__VITE_ASSET__dzhuSTt2__"